import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { Button } from "@/pages/quiz/15000/components/Button";
import { Input } from "@/pages/quiz/15000/components/Input";

const CustomInputQuestion = ({
  question,
  questionValue,

  setQuestionAnswer,
  setQuestionValue,
}: QuizQuestionProps<string>) => {
  const { placeholder = "", maxLength = 100 } = question.attributes;

  return (
    <>
      <Input
        value={questionValue}
        placeholder={(placeholder as string) || ""}
        maxLength={maxLength}
        onChange={(e) => setQuestionValue(e.target.value)}
      />

      <Button
        disabled={!questionValue?.trim()}
        onClick={() => setQuestionAnswer(questionValue)}
      />
    </>
  );
};

export { CustomInputQuestion };
